/**
 * Loại cột - xác định editor, và loại filter của cột - xác định control trong bộ lọc nâng cao
 */
export default {
  Null:-1,
  Text: 0,
  Combobox: 1,
  Number: 2,
  Checkbox: 3,
  Datepicker: 5,
  Dropdown: 6,
  TextArea: 8,
  Enum: 9,
  Action: 10,
  State: 11,
  ComboboxMultiple: 12,
  DateRange: 13,
  Custom: 14,
  DateCombobox:15,
  AddUser: 16,
  ComboboxPriority: 17,
  ComboboxRatingStar: 18,
  ComboboxDocumentSigner: 19, // Combobox người ký
};
